import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCardNfc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCreditCardNfc"><Path d="M12 19.5H2.5V4.5H21.5V9.5H3" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 20C18.5 18.067 20.067 16.5 22 16.5" stroke="currentColor" strokeWidth="0.875036"/><Path d="M15 20C15 16.134 18.134 13 22 13" stroke="currentColor"/></CentralIconBase>;
});

export default IconCreditCardNfc;
